import(/* webpackMode: "eager" */ "/app/src/app/[locale]/error.tsx");
